<template>
  <v-tabs
    center-active
    v-model="activeTab"
  >
    <v-tab
      v-for="(tab, index) in tabs"
      :key="index"
      :href="'#' + tab.id"
      @click.prevent="scrollToSection(tab.id)"
    >
      {{ tab.title }}
    </v-tab>
  </v-tabs>
</template>
<script lang="ts">
import {roles} from "@/enums/roles"
import {mapWritableState} from "pinia"
import {useSettingsPageStore} from "@/stores/settingsPage"

export default {
  computed: {
    ...mapWritableState(useSettingsPageStore, ["activeTab"]),
    tabs() {
      const tabs = [
        { title: 'Personal Details', id: 'personal' },
        { title: 'Event Categories', id: 'categories' },
        { title: 'Connected Calendars', id: 'calendars' },
        { title: 'Users', id: 'members' },
        { title: 'Preferences', id: 'preferences' },
      ]

      if (this.$auth.user?.account.users_count > 1)  {
        tabs.push({ title: 'Default Sharing', id: 'sharing' })
      }

      if (this.$auth.user!.role == roles.ACCOUNT_OWNER) {
        tabs.push({ title: 'Manage Subscription', id: 'subscription' })
      }

      return tabs
    }
  },
  watch: {
    activeTab(newVal) {
      const tab = this.tabs[newVal]
      if (tab && this.$route.hash !== '#' + tab.id) {
        history.replaceState(null, '', `#${tab.id}`)
      }
    },
  },
  methods: {
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId)
      if (section) {
        const y = section.getBoundingClientRect().top + window.scrollY - 80
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        })
        // Explicitly set the active tab when a tab is clicked
        const tabIndex = this.tabs.findIndex(tab => tab.id === sectionId)
        if (tabIndex !== -1) {
          this.activeTab = tabIndex
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.v-tabs .v-btn {
  padding: 8px;
  font-size: 11px;
}

:deep() .v-slide-group__content {
  justify-content: center;
  @media #{map-get(settings.$display-breakpoints, 'xl-and-up')} {
    gap: 20px;
  }
}
</style>
